import { FC } from 'react';
import groupMembersBlackIcon from 'assets/icons/group-members-black-icon.svg';
import { clsx } from 'clsx';
import { formatTeacherName, formatTimeRange } from 'shared/lib';
import { formatDayDate } from 'widgets/schedule/stageTableSchedule/lib';

import { ITeacherRowTableScheduleProps } from '../models/types';

import styles from './styles.module.scss';

export const TeacherRowTableSchedule: FC<ITeacherRowTableScheduleProps> = ({
  data,
}) => {
  return (
    <div className={styles['table-schedule-row']}>
      <div className={styles['table-schedule-cell']}>
        <div className={styles['table-schedule__time-interval']}>
          {`${data.disciplTime} — ${formatTimeRange(data.disciplTime)}`}
        </div>
        {!!data?.dayDate.length && (
          <div className={styles['table-schedule__parity']}>
            {formatDayDate(data?.dayDate)}
          </div>
        )}
      </div>
      <div className={styles['table-schedule-cell']}>
        <div
          className={clsx(
            styles['table-schedule__discipl-type'],
            {
              [styles['table-schedule__discipl-type_blue']]:
                data.disciplType === 'Лабораторная работа',
            },
            {
              [styles['table-schedule__discipl-type_violet']]:
                data.disciplType === 'Практика',
            },
            {
              [styles['table-schedule__discipl-type_red']]:
                data.disciplType === 'Лекция',
            },
          )}
        >
          {data.disciplType}
        </div>
        <div className={styles['table-schedule__tags']}>
          {data.groupsTags.map((tag) => {
            return (
              <div className={styles['table-schedule__tag']} key={tag}>
                <img
                  style={{ marginRight: '2px' }}
                  src={groupMembersBlackIcon}
                  alt="groupMember"
                />
                {tag}
              </div>
            );
          })}
        </div>
        {data?.subgroupNum && (
          <div
            className={styles['table-schedule__subgroup']}
          >{`Подгруппа ${data.subgroupNum}`}</div>
        )}
      </div>
      <div className={styles['table-schedule-cell']}>{data.disciplName}</div>
      <div className={styles['table-schedule-cell']}>{data.location}</div>
      <div className={styles['table-schedule-cell']}>
        <div className={styles['table-schedule__teacher']}>
          {formatTeacherName(data.teacher)}
        </div>
      </div>
    </div>
  );
};
